import { intervalToDuration, format, isSameDay, isSameMonth, isSameYear } from 'date-fns';
import { config } from '@/config';

export function elapsedTime(dateString: string): string {
  const duration = intervalToDuration({
    start: new Date(dateString),
    end: new Date(),
  });

  const year = duration.years;
  if (year) {
    return `${year} year${plural(year)} ago`;
  }

  const month = duration.months;
  if (month) {
    return `${month} month${plural(month)} ago`;
  }

  const week = duration.weeks;
  if (week) {
    return `${week} week${plural(week)} ago`;
  }

  const day = duration.days;
  if (day) {
    return `${day} day${plural(day)} ago`;
  }

  const hour = duration.hours;
  if (hour) {
    return `${hour} hour${plural(hour)} ago`;
  }

  const minute = duration.minutes;
  if (minute) {
    return `${minute} minute${plural(minute)} ago`;
  }

  return 'just now';
}

export const plural = (value: number) => value === 1 ? '' : 's';

export const formatDate = (startDate: Date, endDate?: Date): string => {
  if (endDate) {
    if (endDate < startDate) {
      return `${format(startDate, 'eee dd MMM yyyy')}`;
    }

    if (!isSameYear(startDate, endDate)) {
      return `${format(startDate, 'dd MMM yyyy')} - ${format(endDate, 'dd MMM yyyy')}`;
    }

    if (!isSameMonth(startDate, endDate)) {
      return `${format(startDate, 'dd MMM')} - ${format(endDate, 'dd MMM')} ${format(startDate, 'yyyy')}`;
    }

    if (!isSameDay(startDate, endDate)) {
      return `${format(startDate, 'dd')} - ${format(endDate, 'dd')} ${format(startDate, 'MMM yyyy')}`;
    }
  }

  return `${format(startDate, 'eee dd MMM yyyy')}`;
};

export const getParentScopedStyleAttrs = (parent: Vue) => {
  if ((parent.$options as any)._scopeId) {
    const attrs = {} as { [key: string]: ''};
    attrs[`${(parent.$options as any)._scopeId}`] = '';
    return attrs;
  }

  return {};
};

export const getLocalCountry = async () => {
  try {
    const response = await fetch(`https://pro.ip-api.com/json?key=${config.ip_api_key}`);
    const data = await response.json();
    return (data.countryCode as string).toLowerCase();
  } catch (error) {
    console.log(error);
    // return undefined;
    return 'za';
  }
};
